// extracted by mini-css-extract-plugin
var _1 = "TableCellInfo-moduleTableCellInfo__ILZHF IconNG-moduleiconContainer__SxWZ0";
export { _1 as "TableCellInfo" }
